<template>
  <b-card no-body>
    <b-card-body>
      <b-card-title>
        <h5>{{ title }} <small>{{ url }}</small></h5>
      </b-card-title>
    </b-card-body>
    <b-img 
      v-if="foto" 
      :src="foto.secure_url" 
      class="card-img-top"
    />
    <b-card-body v-if="foto">
      {{ foto.created_at | formatDateTime }}
      <br>
      <small>{{ foto.public_id }}</small>
    </b-card-body>
    <b-card-footer>
      <upload-file
        v-if="uploadfolder && !foto"
        :public_id="public_id"
        :folder="uploadfolder"
        :preset="preset"
        cloud="tranpslan"
        @file-uploaded="opslaanFoto($event)"
      />

      <div v-if="foto">
        <b-button 
          v-if="foto" 
          :id="popoverId" 
          variant="warning"
        >
          {{ title }} VERWIJDEREN
        </b-button>
        <b-popover 
          ref="popoverVerwijderen" 
          :target="popoverId" 
          triggers="click focus" 
          placement="right"
        >
          <template #title>
            Zeker weten?
          </template>
          <b-button 
            variant="danger" 
            class="mr-2" 
            @click="verwijderenFoto()"
          >
            Ja
          </b-button>
          <b-button 
            variant="success" 
            @click="$refs.popoverVerwijderen.$emit('close');"
          >
            Nee
          </b-button>
        </b-popover>
      </div>
      <slot />
    </b-card-footer>
  </b-card>
</template>
<script>
import UploadFile from "@/components/UploadFile"; // directe upload naar cloudinary

export default {
  name: "CloudFoto",
  components: {
    UploadFile
  },
  mixins: [],
  props: {
    url:{
      type: String,
      default: null
    },
    title: {
      type: String,
      default: "Cloudfoto"
    },
    uploadfolder: {
      type: String,
      default: "unknowm"
    },
    public_id:{
      type: String,
      default: null
    },
    preset: {
      type: String,
      default: "default_cloudfoto"
    }
  },
  data() {
    return {
      foto: null
    };
  },
  computed: {
    popoverId: function() {
      return ("foto-verwijderen-" + this.title).toLowerCase();
    }
  },
  mounted() {
    this.getFoto();
  },
  methods: {
    opslaanFoto(foto) {
      var vm = this;
      this.$http
        .post(this.url, {foto: foto})
        .then(function(response) {
          console.dir("bijgewerkt api", vm.url);
          console.dir(response.data);
          vm.foto = response.data.foto;
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    verwijderenFoto() {
      var vm = this;
      this.$http
        .delete(this.url, { data: { public_ids: [ this.foto.public_id ] } })
        .then(function(response) {
          console.dir(response.data);
          vm.foto = null;
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    getFoto() {
      var vm = this;
      return this.$http
        .get(this.url)
        .then(function(response) {
          vm.foto = response.data.foto;
        })
        .catch(function(error) {
          console.log(error);
        });
    }
  },
};
</script>